import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Table } from 'antd';
import FormList from './FormList';
import {
  ACTION_TYPE,
  getJournalList,
} from '../../../actions/user';
import './style.css';

const mapDispatchToProps = (dispatch: any) => ({
  getJournalList: (value) => dispatch(getJournalList(value))
});

const mapStateToProps = (user: any) => (user);

interface Props {
  getJournalList: (value) => any;
  user: any;
}

const Journal = (props: Props) => {
  const [data, setData] = useState('');
  const [searchValue, setSearchValue] = useState({
    userName: undefined,
    times: undefined
  });
  useEffect(() => {
    const params = {
      page: 1,
      size: 10
    }
    props.getJournalList(params)
  }, [data])

  const columns = [
    {
      title: '用户名',
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '操作',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '操作地址',
      dataIndex: 'ip',
      key: 'ip',
    },
    {
      title: '操作时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
  ];

  const onChange = (page, size) => {
    const params = {
      page,
      size,
      userName: searchValue.userName,
      times: searchValue.times
    }
    props.getJournalList(params)
  }

  const onShowSizeChange = (page, size) => {
    const params = {
      page,
      size,
      userName: searchValue.userName,
      times: searchValue.times
    }
    props.getJournalList(params)
  }

  const { user } = props;
  const { journalList, loading } = user;
  let dataSource = journalList.list.map((item, index) => ({
    ...item,
    key: index + 1
  }))
  const total = journalList.total;
  return (
    <div className="journal">
      <h2>日志查询</h2>
      <FormList 
      getJournalList={props.getJournalList}
      setSearchValue={setSearchValue}
      />
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading[ACTION_TYPE.GET_JOURNAL_LIST]}
        pagination={{
          // size: "small",
          total: total,
          showTotal: (total) => { return `共【${total}】条` },
          showSizeChanger: true,
          showQuickJumper: true,
          onShowSizeChange: onShowSizeChange,
          onChange: onChange
        }}
      />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Journal)